module.exports = __webpack_public_path__ + "static/media/SarahSwitek_11_Questions-Conclusion_4.3c84be52.mp3";